"use client";

import { getRouteApi, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { Header } from "../../components/header";
import { OtpCard } from "../../components/otp-card";
import { useAuth } from "../../hooks/use-auth";
import { readOtpSession } from "../../services/otp-session";

const routeApi = getRouteApi("/auth/verify");

export const OtpVerifyPage = () => {
  const navigate = useNavigate();
  const searchParams = routeApi.useSearch();
  const page = searchParams.page;
  const { isAuthenticated } = useAuth();
  const [hasToken, setHasToken] = useState(false);

  useEffect(() => {
    const session = readOtpSession();
    setHasToken(!!session);

    if (!session && !isAuthenticated) {
      navigate({
        to: "/auth/login"
      });
    }
  }, [navigate, isAuthenticated]);

  if (!hasToken) {
    return null;
  }

  return (
    <>
      <Header />
      <div className="flex justify-center items-center h-full">
        <OtpCard page={page} />
      </div>
    </>
  );
};
